// logout.js
import api from "../api/api";

export const logout = async () => {
  try {
    await api.post("/auth/logout");
  } catch (e) {
    // ignore
  } finally {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("role");
    window.location.href = "/";
  }
};
